module.exports = __webpack_public_path__ + "img/AMWET2.90d07925.jpg";